/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTrxCountInfo } from './EvmTrxCountInfo';

export type HumanityBlockDetailInfo = {
    BNO: string;
    BHA: string;
    TCNTINFO: EvmTrxCountInfo;
    AG: string;
    UT: number;
    BS: HumanityBlockDetailInfo.BS;
    L1BN: string;
    BTNO: string;
    PT: string;
    CMTRX: string;
    CFTRX: string;
    GU: string;
    GUP: string;
    GL: string;
    BFPG: string;
    BFPGG: string;
    BF: string;
    PRHA: string;
    DF: string;
    TDF: string;
    SI: string;
    SDCNT: string;
    SDRT: string;
    DM: string;
    RT: string;
    TR: string;
    ST: string;
    S3U: string;
    NON: string;
};

export namespace HumanityBlockDetailInfo {

    export enum BS {
        PROCESSED_ON_L2 = 'PROCESSED_ON_L2',
        POSTED_ON_L1 = 'POSTED_ON_L1',
        CONFIRMED_ON_L1 = 'CONFIRMED_ON_L1',
    }


}

